<fcom-flight-card
  *ngIf="bound"
  [disabled]="false"
  [type]="
    type === 'outbound'
      ? ('ticketSelection.departure' | finLocalization)
      : type === 'inbound'
        ? ('ticketSelection.return' | finLocalization)
        : null
  "
  [date]="bound.departure.dateTime | finDateFormat: 'FULL_NO_YEAR'"
  [fareDetail]="bound?.fareFamily?.name || (cabin ? ('travelClass.' + cabin.toLowerCase() | finLocalization) : '')"
>
  <fcom-ufo
    [departure]="{
      dateTime:
        (bound.departure.dateTime | finTime) + ' ' + (bound.departure.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
      city: locations[bound.departure.locationCode]?.cityName,
      airportCode: bound.departure.locationCode,
      airport: locations[bound.departure.locationCode]?.name,
    }"
    [arrival]="{
      dateTime: (bound.arrival.dateTime | finTime) + ' ' + (bound.arrival.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
      city: locations[bound.arrival.locationCode]?.cityName,
      airportCode: bound.arrival.locationCode,
      airport: locations[bound.arrival.locationCode]?.name,
    }"
    [tails]="tails | finTailNames"
    [isByBusOnly]="isByBusOnly"
    [airlines]="bound.uniqueAirlineNames"
    [duration]="bound.duration | finDuration | async"
    [stops]="bound.stops"
    (viewDetails)="openViewDetails()"
    [flightNumbers]="bound.itinerary | finFlightNumbers"
  />
</fcom-flight-card>

<fcom-modal
  [open]="modalOpen"
  (openChange)="modalOpen = $event"
  [title]="'MMB.view.itineraryModal.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
>
  <fin-itinerary-timeline
    [bound]="bound"
    [locations]="locations"
    [boundType]="type"
    class="block pr-medium"
    [isBookingFlow]="isBookingFlow"
  />
</fcom-modal>
